import React from 'react';
import { FormControlLabel, Switch, FormHelperText } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';

const RMSSwitch = ({ name, label, disabled = false }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ field, fieldState: { error } }) => (
        <>
          <FormControlLabel
            control={
              <Switch
                checked={!!field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                color="primary"
                disabled={disabled}
              />
            }
            label={label}
          />

          {error && <FormHelperText error>{error.message}</FormHelperText>}
        </>
      )}
    />
  );
};

export default RMSSwitch;